import { render, staticRenderFns } from "./AddShareList.vue?vue&type=template&id=76c40f24&scoped=true"
import script from "./AddShareList.vue?vue&type=script&lang=js"
export * from "./AddShareList.vue?vue&type=script&lang=js"
import style0 from "./AddShareList.vue?vue&type=style&index=0&id=76c40f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c40f24",
  null
  
)

export default component.exports